import React, { useEffect, useState } from "react";
import endpoints from "../../endpoint";
import axios from "axios";

const OverviewCards = ({ partner }) => {
  const [totalDeals, setTotalDeals] = useState(0);
  const [totalLeads, setTotalLeads] = useState(0);
  const [totalDealsEarning, setTotalDealsEarning] = useState(0);
  console.log("totalDealsEarning", totalDealsEarning);
  const [totalAmountReceived, setTotalAmountReceived] = useState(0);
  console.log("totalAmountReceived", totalAmountReceived);

  useEffect(() => {
    const fetchPartnerDeals = async () => {
      const user = JSON.parse(sessionStorage.getItem("user"));
      try {
        const response = await axios.get(
          `${endpoints.serverBaseUrl}api/partner/partner-deals/${user.userId}`,
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        setTotalDeals(response.data.deals.length);
        setTotalDealsEarning(response.data.deals);
        setTotalAmountReceived(response.data.totalAmountReceived);
      } catch (error) {
        console.error("Error fetching partner deals:", error);
      }
    };

    fetchPartnerDeals();
  }, []);

  useEffect(() => {
    const fetchPartnerLeads = async () => {
      const user = JSON.parse(sessionStorage.getItem("user"));
      try {
        const response = await axios.get(
          `${endpoints.serverBaseUrl}api/partner/partner-leads/${user.userId}`,
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        setTotalLeads(response.data.leads.length);
      } catch (error) {
        console.error("Error fetching partner leads:", error);
      }
    };

    fetchPartnerLeads();
  }, []);
  return (
    <div class="grid items-center justify-center grid-cols-2 md:grid-cols-3 lg:px-4 lg:grid-cols-6 gap-4 mb-4">
      <div class="bg-red-300 p-4 rounded-lg">
        <div class="text-white font-bold">Total Referral</div>
        <div class="text-2xl font-bold text-white">
          {partner?.totalReferrals || 0}
        </div>
      </div>

      <div class="bg-green-300 p-4 rounded-lg">
        <div class="text-white font-bold">Referral Earning</div>
        <div class="text-2xl font-bold text-white">
          ₹{Math.floor(partner?.totalEarnings) || 0}
        </div>
      </div>

      <div class="p-4 rounded-lg" style={{ backgroundColor: "#4BB4FF" }}>
        <div class="text-white font-bold">Commission Rate</div>
        <div class="text-2xl font-bold text-white">
          {partner?.commissionRate || 0}%
        </div>
      </div>

      <div className="bg-blue-300 p-4 rounded-lg">
        <div className="text-white font-bold">Total Deals</div>
        <div className="text-2xl font-bold text-white">{totalDeals}</div>
      </div>

      <div
        className="p-4 rounded-lg"
        style={{ backgroundColor: "#A07CF0", color: "white" }}
      >
        <div className="text-white font-bold">Total Leads</div>
        <div className="text-2xl font-bold text-white">{totalLeads}</div>
      </div>

      <div class="bg-green-300 p-4 rounded-lg">
        <div class="text-white font-bold">Deals Earning</div>
        <div class="text-2xl font-bold text-white">
          ₹{Math.floor(totalAmountReceived)}
        </div>
      </div>
    </div>
  );
};

export default OverviewCards;
